<template>
  <header class="header">
    <div class="container">
      <div class="header__inner">

        <Menu/>

        <LocaleSwitcher />

        <Profile/>

      </div>
    </div>
  </header>
</template>

<script>
import {mapGetters} from 'vuex'
import Menu from '@/components/Layouts/Header/Menu/Menu'
import Profile from "@/components/Layouts/Header/Profile/Profile";
import LocaleSwitcher from '@/components/Layouts/Header/Menu/LocaleSwitcher'
import {Trans} from "@/plugins/Translation";

export default {
  name: 'Header',

  components: {
    LocaleSwitcher,
    Profile,
    Menu
  },
  computed: {
    ...mapGetters({}),
  },
}
</script>

<style lang="scss" scoped>
</style>
